"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pricingFormulaItemTotal = exports.pricingFormulaItemValue = exports.pricingFormulaItemValueWithinRange = exports.pricingFormulaItemIsRelevant = exports.pricingFormulaItemConditionWithRange = exports.pricingFormulaItemDeserialize = void 0;
const round_1 = __importDefault(require("lodash/round"));
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const PricingFormulaInput_1 = require("./PricingFormulaInput");
const PricingFormulaItemCondition_1 = require("./PricingFormulaItemCondition");
function pricingFormulaItemDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        name: (0, unwrap_1.default)(object.name, deserializeString_1.deserializeString),
        amount: (0, deserializeNumber_1.deserializeNumber)(object.amount),
        input: (0, unwrap_1.default)(object.input, PricingFormulaInput_1.pricingFormulaInputDeserialize),
        conditions: (0, unwrap_1.default)(object.conditions, (0, deserializeArray_1.default)(PricingFormulaItemCondition_1.pricingFormulaItemConditionDeserialize)),
    };
}
exports.pricingFormulaItemDeserialize = pricingFormulaItemDeserialize;
// ------------------------------------------------------------------------------------------------------------ //
// condition with range
function pricingFormulaItemConditionWithRange(item) {
    var _a;
    return (_a = item.conditions) === null || _a === void 0 ? void 0 : _a.find(condition => condition.applyRangeToInputValue &&
        condition.input === item.input &&
        (condition.minimumInclusive || condition.maximumExclusive));
}
exports.pricingFormulaItemConditionWithRange = pricingFormulaItemConditionWithRange;
// is relevant
function pricingFormulaItemIsRelevant(item, charge, miles, minutes, tip, revenue) {
    // input but no input value?
    if (item.input && !(0, PricingFormulaInput_1.pricingFormulatInputValue)(item.input, charge, miles, minutes, tip, revenue)) {
        return false;
    }
    // check conditions
    if (item.conditions) {
        // find failed condition
        const failedCondition = item.conditions.find(condition => {
            const conditionValue = (0, PricingFormulaInput_1.pricingFormulatInputValue)(condition.input, charge, miles, minutes, tip, revenue);
            return !(0, PricingFormulaItemCondition_1.pricingFormulaItemConditionIsInRange)(condition, conditionValue);
        });
        // found a failed condition
        if (failedCondition) {
            return false;
        }
    }
    // passed
    return true;
}
exports.pricingFormulaItemIsRelevant = pricingFormulaItemIsRelevant;
function pricingFormulaItemValueWithinRange(item, value) {
    const condition = pricingFormulaItemConditionWithRange(item);
    if (condition) {
        let valueWithinRange = value;
        if (condition.maximumExclusive && valueWithinRange > condition.maximumExclusive) {
            valueWithinRange = condition.maximumExclusive;
        }
        if (condition.minimumInclusive && valueWithinRange >= condition.minimumInclusive) {
            valueWithinRange -= condition.minimumInclusive;
        }
        if (valueWithinRange === value) {
            return undefined;
        }
        return (0, round_1.default)(valueWithinRange, 2);
    }
    else {
        return undefined;
    }
}
exports.pricingFormulaItemValueWithinRange = pricingFormulaItemValueWithinRange;
function pricingFormulaItemValue(item, charge, miles, minutes, tip, revenue) {
    var _a;
    if (item.input) {
        const value = (0, PricingFormulaInput_1.pricingFormulatInputValue)(item.input, charge, miles, minutes, tip, revenue);
        return (_a = pricingFormulaItemValueWithinRange(item, value)) !== null && _a !== void 0 ? _a : value;
    }
    else {
        return item.amount;
    }
}
exports.pricingFormulaItemValue = pricingFormulaItemValue;
function pricingFormulaItemTotal(item, charge, miles, minutes, tip, revenue) {
    if (item.input) {
        return (0, round_1.default)(pricingFormulaItemValue(item, charge, miles, minutes, tip, revenue) * item.amount, 2);
    }
    else {
        return item.amount;
    }
}
exports.pricingFormulaItemTotal = pricingFormulaItemTotal;
